import { isEmpty } from "lodash";
import {
  GET_CSAT_INFO,
  CHANGE_DISTRIBUTION,
  CHANGE_SNIPPET_TEXT,
  CHANGE_COMMENT_TEXT,
  CHANGE_SUBMIT_TEXT,
  CHANGE_THANKYOU_TEXT,
  CHANGE_SNIPPET_TYPE,
  CHANGE_CSAT_TEXT_RATINGS,
  CHANGE_CSAT_ORDERING,
  SET_LAST_UPDATE,
  UNSAVED_CHANGES_STATE,
  CHANGE_SEND_SURVEY,
  CHANGE_EXCLUDE_DOMAIN,
  CHANGE_IS_BLOCKED_DOMAINS_ENABLED
} from "../actions/types";

export default (state = null,action) => {
  switch(action.type){
    case GET_CSAT_INFO:
      return action.payload;
    case CHANGE_DISTRIBUTION:
      return {...state, distribution : action.payload};
    case CHANGE_SNIPPET_TEXT:
      return {...state, snippet_text : action.payload};
    case CHANGE_COMMENT_TEXT:
      return {...state, comment_text : action.payload};
    case CHANGE_SUBMIT_TEXT:
      return {...state, submit_text : action.payload};
    case CHANGE_THANKYOU_TEXT:
      return {...state, thankyou_text : action.payload};
    case CHANGE_SNIPPET_TYPE:
      return {...state, snippet_type: action.payload};
    case CHANGE_CSAT_TEXT_RATINGS:
      return {...state, rating_options: action.payload};
    case CHANGE_CSAT_ORDERING:
      return {...state, rating_order: action.payload};
    case SET_LAST_UPDATE:
      return {
        ...state,
        updated_at : action.payload.lastUpdatedAt,
        last_updated_by : action.payload.lastUpdatedBy
      };
    case UNSAVED_CHANGES_STATE:
      return {...state, unsaved_changes_state: action.payload};
    case CHANGE_SEND_SURVEY:
      return {...state, preventCSATAfterFeedback: action.payload};
    case CHANGE_EXCLUDE_DOMAIN:
      return {
        ...state,
        blockDomains: isEmpty(action.payload)
          ? null
          : JSON.stringify({
              blocked: action.payload
            })
      };
    case CHANGE_IS_BLOCKED_DOMAINS_ENABLED:
      return { ...state, blockDomainsEnabled: action.payload };
    default :
      return state;
  }
};
